import { defineTokens } from "@chakra-ui/react";

const colors = defineTokens.colors({
  brand: {
    5: { value: "#f1f8ff" },
    10: { value: "#f1f8ff" },
    20: { value: "#e3f2f9" },
    30: { value: "#c5e4f3" },
    40: { value: "#a2d4ec" },
    50: { value: "#e3f2f9" },
    100: { value: "#c5e4f3" },
    200: { value: "#a2d4ec" },
    300: { value: "#7ac1e4" },
    400: { value: "#47a9da" },
    500: { value: "#0088cc" }, // main
    600: { value: "#007ab8" },
    700: { value: "#006ba1" },
    800: { value: "#005885" },
    900: { value: "#003f5e" },
  },
  money: {
    50: { value: "#e8f5e9" },
    100: { value: "#c8e6c9" },
    200: { value: "#a5d6a7" },
    300: { value: "#81c784" },
    400: { value: "#66bb6a" },
    500: { value: "#00c853" }, // main
    600: { value: "#00c853" },
    700: { value: "#00c853" },
    800: { value: "#00c853" },
    900: { value: "#00c853" },
  },
  success: {
    50: { value: "#E8F5E9" },
    100: { value: "#C8E6C9" },
    200: { value: "#A5D6A7" },
    300: { value: "#81C784" },
    400: { value: "#66BB6A" },
    500: { value: "#00C853" }, // Success Green
    600: { value: "#00C853" },
    700: { value: "#00C853" },
    800: { value: "#00C853" },
    900: { value: "#00C853" },
  },
  fail: {
    50: { value: "#FFEBEE" },
    100: { value: "#FFCDD2" },
    200: { value: "#EF9A9A" },
    300: { value: "#E57373" },
    400: { value: "#EF5350" },
    500: { value: "#F44336" }, // Fail Red
    600: { value: "#F44336" },
    700: { value: "#F44336" },
    800: { value: "#F44336" },
    900: { value: "#F44336" },
  },
  pending: {
    50: { value: "#FFFDE7" },
    100: { value: "#FFF9C4" },
    200: { value: "#FFF59D" },
    300: { value: "#FFF176" },
    400: { value: "#FFEE58" },
    500: { value: "#FFC107" }, // Warning Yellow
    600: { value: "#FFC107" },
    700: { value: "#FFC107" },
    800: { value: "#FFC107" },
    900: { value: "#FFC107" },
  },

  error: {
    50: { value: "#FFEBEE" },
    100: { value: "#FFCDD2" },
    200: { value: "#EF9A9A" },
    300: { value: "#E57373" },
    400: { value: "#EF5350" },
    500: { value: "#F44336" }, // Fail Red
    600: { value: "#F44336" },
    700: { value: "#F44336" },
    800: { value: "#F44336" },
    900: { value: "#F44336" },
  },
  warning: {
    50: { value: "#FFF3E0" },
    100: { value: "#FFE0B2" },
    200: { value: "#FFCC80" },
    300: { value: "#FFB74D" },
    400: { value: "#FFA726" },
    500: { value: "#FF9800" }, // Warning Yellow
    600: { value: "#FF9800" },
    700: { value: "#FF9800" },
    800: { value: "#FF9800" },
    900: { value: "#FF9800" },
  },
  info: {
    50: { value: "#E3F2FD" },
    100: { value: "#BBDEFB" },
    200: { value: "#90CAF9" },
    300: { value: "#1c83d8ff" },
    400: { value: "#42A5F5" },
    500: { value: "#2196F3" }, // Blue
    600: { value: "#1E88E5" },
    700: { value: "#1976D2" },
    800: { value: "#1565C0" },
    900: { value: "#0D47A1" },
  },
  gray: {
    50: { value: "#FAFAFA" },
    100: { value: "#F5F5F5" },
    200: { value: "#EEEEEE" },
    300: { value: "#E0E0E0" },
    400: { value: "#BDBDBD" },
    500: { value: "#9E9E9E" }, // Gray
    600: { value: "#757575" },
    700: { value: "#616161" },
    800: { value: "#424242" },
    900: { value: "#212121" },
  },
  black: {
    50: { value: "#000000" },
    100: { value: "#000000" },
    200: { value: "#000000" },
    300: { value: "#000000" },
    400: { value: "#000000" },
    500: { value: "#000000" }, // Black
    600: { value: "#000000" },
    700: { value: "#000000" },
    800: { value: "#000000" },
    900: { value: "#000000" },
  },
  white: {
    50: { value: "#FFFFFF" },
    100: { value: "#FFFFFF" },
    200: { value: "#FFFFFF" },
    300: { value: "#FFFFFF" },
    400: { value: "#FFFFFF" },
    500: { value: "#FFFFFF" }, // White
    600: { value: "#FFFFFF" },
    700: { value: "#FFFFFF" },
    800: { value: "#FFFFFF" },
    900: { value: "#FFFFFF" },
  },
  danger: {
    50: { value: "#FFEBEE" },
    100: { value: "#FFCDD2" },
    200: { value: "#EF9A9A" },
    300: { value: "#E57373" },
    400: { value: "#EF5350" },
    500: { value: "#d32f2f" }, // Fail Red
    600: { value: "#d32f2f" },
    700: { value: "#d32f2f" },
    800: { value: "#d32f2f" },
    900: { value: "#d32f2f" },
  },
});

export default colors;
